import type { CertificateStatus, JobStatus } from '@/deploy/types/network';

type Tone = 'neutral' | 'primary' | 'success' | 'warning' | 'danger' | 'info' | 'muted';

/** Jours restants avant une date (négatif si passée), null si pas de date. */
export function daysUntil(iso: string | null | undefined): number | null {
  if (!iso) return null;
  return Math.floor((new Date(iso).getTime() - Date.now()) / 86_400_000);
}

/** Libellé et couleur de l'expiration d'un certificat. */
export function expiryBadge(iso: string | null | undefined): { tone: Tone; label: string } {
  const days = daysUntil(iso);
  if (days === null) return { tone: 'muted', label: 'Aucun certificat' };
  if (days < 0) return { tone: 'danger', label: 'Expiré' };
  if (days < 7) return { tone: 'danger', label: `${days} j` };
  if (days < 21) return { tone: 'warning', label: `${days} j` };
  return { tone: 'success', label: `${days} j` };
}

export const CERT_STATUS: Record<CertificateStatus, { tone: Tone; label: string }> = {
  PENDING: { tone: 'info', label: 'En attente' },
  VALID: { tone: 'success', label: 'Valide' },
  FAILED: { tone: 'danger', label: 'Échec' },
  EXPIRED: { tone: 'danger', label: 'Expiré' },
};

export const JOB_STATUS: Record<JobStatus, { tone: Tone; label: string }> = {
  PENDING: { tone: 'muted', label: 'En file' },
  RUNNING: { tone: 'info', label: 'En cours' },
  SUCCESS: { tone: 'success', label: 'Terminé' },
  FAILED: { tone: 'danger', label: 'Échec' },
};

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '-';
  return new Date(iso).toLocaleString('fr-FR', { dateStyle: 'short', timeStyle: 'short' });
}

export function errorMessage(e: unknown): string {
  return e instanceof Error ? e.message : 'Erreur inconnue';
}
